<template>
    <span>
        <slot
            v-bind="{
                ...$data,
                methods: {
                    initializeEmbed,
                    setGlobalConfig,
                    destroyPlayer,
                    setEmbedSetting,
                }
            }"
        />
    </span>
</template>

<script>
import { upperFirst } from 'lodash';

export default {
    data: () => ({
        playerEmbed: false,
        embedSettings: {},
    }),

    methods: {
        /**
         * Initializes embed
         *
         */
        initializeEmbed() {
            window.addEventListener('loadFuseboxPlayer', this.loadPlayerEmbedConfig);

            this.$once('hook:destroyed', () => {
                window.removeEventListener('loadFuseboxPlayer', this.loadPlayerEmbedConfig);
                this.destroyPlayer();
            });
        },

        /**
         * Loads initial player config
         *
         * @param  {object}  event Player event
         */
        loadPlayerEmbedConfig(event) {
            this.playerEmbed = window.fuseboxPlayer(event.detail);
            this.playerEmbed.setConfig(this.embedSettings);
        },

        /**
         * Destroys player instance
         *
         */
        destroyPlayer() {
            if (this.playerEmbed) {
                this.playerEmbed.remove();
                this.playerEmbed = false;
            }
        },

        /**
         * Set embed global config
         *
         * @param {object} embedSettings Embed settings object
         */
        setGlobalConfig(embedSettings) {
            this.embedSettings = {
                ...this.emembedSettings,
                ...embedSettings,
            };

            if (this.playerEmbed) {
                this.playerEmbed.setConfig(this.embedSettings);
            }
        },

        /**
         * Change embed settings
         *
         * @param   {object}  data  Embed Settings
         *
         */
        setEmbedSetting(data) {
            for (const key in data) {
                this.playerEmbed[`set${upperFirst(key)}`](data[key]);
            }
        },
    },
};
</script>
